import { useState } from 'react';

/** Round avatar: the photo, or the first letter of the name on `surface`. */
export function Avatar({
	name,
	photoUrl,
	size = 'size-10',
}: {
	/** Null: a deleted account (T-804), drawn as «?». */
	name: string | null;
	photoUrl: string | null;
	size?: string;
}) {
	// An unreachable image falls back to the initial instead of the browser's broken-image icon.
	const [failedUrl, setFailedUrl] = useState<string | null>(null);
	if (photoUrl !== null && photoUrl !== failedUrl) {
		// Lists can hold many avatars: decode off the main thread, fetch only near the viewport.
		return (
			<img
				src={photoUrl}
				alt=""
				loading="lazy"
				decoding="async"
				onError={() => {
					setFailedUrl(photoUrl);
				}}
				className={`${size} shrink-0 rounded-full object-cover`}
			/>
		);
	}
	return (
		<span
			aria-hidden="true"
			className={`${size} bg-border text-text flex shrink-0 items-center justify-center rounded-full font-semibold`}
		>
			{(name ?? '').trim().charAt(0).toUpperCase() || '?'}
		</span>
	);
}
